<template>
  <b-container fluid>
    <b-row no-gutters class="bordered-box-header align-items-center">
      <h2>{{pageTitle}}</h2>
    </b-row>
    <b-row no-gutters class="bordered-box">
      <b-form @submit.prevent="onSubmit" class="col-12">
        <b-form-group class="required" label="Imię">
          <b-form-input
            v-model="firstName"
            type="text"
            autocomplete="off"
            :state="$v.firstName.$error? false : null"
            @input="$v.firstName.$reset()"
          />
          <b-form-invalid-feedback>
            <div v-if="!$v.firstName.required">To pole jest wymagane</div>
          </b-form-invalid-feedback>
        </b-form-group>

        <b-form-group class="required" label="Nazwisko">
          <b-form-input
            v-model="lastName"
            type="text"
            autocomplete="off"
            :state="$v.lastName.$error? false : null"
            @input="$v.lastName.$reset()"
          />
          <b-form-invalid-feedback>
            <div v-if="!$v.lastName.required">To pole jest wymagane</div>
          </b-form-invalid-feedback>
        </b-form-group>

        <b-form-group class="required" label="Email">
          <b-form-input
            v-model="email"
            type="text"
            autocomplete="off"
            :state="$v.email.$error? false : null"
            @input="$v.email.$reset()"
            :disabled="lectorId"
          />
          <b-form-invalid-feedback>
            <div v-if="!$v.email.email">Nieprawidłowy email</div>
            <div v-if="!$v.email.required">To pole jest wymagane</div>
          </b-form-invalid-feedback>
        </b-form-group>

        <b-form-group v-if="!lectorId">
          <b-form-checkbox switch v-model="unlocked" @change="$v.$reset()">Konto aktywne</b-form-checkbox>
        </b-form-group>

        <b-form-group class="required" label="Nr telefonu">
          <b-form-input
            v-model="phoneNumber"
            type="text"
            autocomplete="off"
            :state="$v.phoneNumber.$error? false : null"
            @input="$v.phoneNumber.$reset()"
          />
          <b-form-invalid-feedback>
            <div v-if="!$v.phoneNumber.required">To pole jest wymagane</div>
          </b-form-invalid-feedback>
        </b-form-group>

        <b-form-group class="required" label="Skype">
          <b-form-input
            v-model="skype"
            type="text"
            autocomplete="off"
            :state="$v.skype.$error? false : null"
            @input="$v.skype.$reset()"
          />
          <b-form-invalid-feedback>
            <div v-if="!$v.skype.required">To pole jest wymagane</div>
          </b-form-invalid-feedback>
        </b-form-group>

        <b-form-group label="Opis">
          <b-form-textarea v-model="description" rows="3" max-rows="6" autocomplete="off" />
        </b-form-group>

        <b-form-group class="text-right">
          <hr />
          <b-button
            type="submit"
            variant="primary"
            class="mr-1"
            :disabled="saving"
            @click="$v.$touch"
          >
            <span v-show="!saving">Zapisz</span>
            <span v-show="saving">
              <b-spinner small label="Proszę czekać..."></b-spinner>
            </span>
          </b-button>
          <b-button class="mr-1" variant="secondary" @click="$router.go(-1)">Powrót</b-button>
          <b-button variant="link" @click="goToDetails" v-if="lectorId">Szczegóły</b-button>
        </b-form-group>
      </b-form>
    </b-row>
  </b-container>
</template>



<script>
import { axios, eventBus } from "@/_infrastructure";
import { required, email } from "vuelidate/lib/validators";

export default {
  data() {
    return {
      saving: false,
      lectorId: this.id,
      firstName: null,
      lastName: null,
      skype: null,
      unlocked: true,
      phoneNumber: null,
      email: null,
      emailConfirmed: false,
      description: null
    };
  },
  computed: {
    pageTitle() {
      if (this.lectorId) {
        return "Edycja konta lektora";
      } else {
        return "Utwórz nowe konto lektora";
      }
    }
  },
  props: ["id"],
  validations: {
    firstName: {
      required
    },
    lastName: {
      required
    },
    skype: {
      required
    },
    phoneNumber: {
      required
    },
    email: {
      required,
      email
    }
  },
  mounted() {
    if (this.id) {
      let loader = this.$loading.show({
        container: this.$refs.mainContainer
      });
      axios
        .get("/lectors/details", {
          params: {
            id: this.id
          }
        })
        .then(response => {
          var result = response.data;
          this.firstName = result.firstName;
          this.lastName = result.lastName;
          this.skype = result.skype;
          this.email = result.email;
          this.emailConfirmed = result.emailConfirmed;
          this.description = result.description;
          this.phoneNumber = result.phoneNumber;
        })
        .catch(error => eventBus.$emit("unhandled-error", error))
        .then(() => {
          loader.hide();
        });
    }
  },
  methods: {
    goto(url) {
      this.$router.push(url);
    },
    goToDetails() {
      this.$router.push({ path: `/site/lectors/details/${this.lectorId}` });
    },
    onSubmit() {
      if (!this.$v.$error) {
        this.saving = true;

        axios[this.lectorId ? "put" : "post"]("/lectors", {
          id: this.lectorId,
          firstName: this.firstName,
          lastName: this.lastName,
          skype: this.skype,
          phoneNumber: this.phoneNumber,
          email: this.email,
          description: this.description,
          locked: !this.unlocked
        })
          .then(response => {
            var result = response.data;
            this.lectorId = result;
            eventBus.$emit("notify-success", "Zapisano poprawnie.");
          })
          .catch(error => eventBus.$emit("unhandled-error", error))
          .then(() => (this.saving = false));
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.bordered-box-header {
  margin-top: 20px;
  padding: 10px;
  margin-bottom: 0px;
  background: rgba(0, 0, 0, 0.03);
  border: 1px solid rgba(0, 0, 0, 0.125);
}

.bordered-box {
  border: 1px solid rgba(0, 0, 0, 0.125);
  padding: 10px;
}
</style>